/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'navigation';
const componentName = 'operations-vertical-nav';
const prefix = `${moduleName}.${componentName}`;

export const allAlertsLabel = `${prefix}.allAlertsLabel`;
export const alertConfigLabel = `${prefix}.alertConfigLabel`;
export const alertActionsLabel = `${prefix}.alertActionsLabel`;
export const allEventsLabel = `${prefix}.allEventsLabel`;
export const configAuditTrailLabel = `${prefix}.configAuditTrailLabel`;
export const notificationsLabel = `${prefix}.notificationsLabel`;
export const snmpTrapLabel = `${prefix}.snmpTrapLabel`;
export const trafficCaptureLabel = `${prefix}.trafficCaptureLabel`;
export const reportsLabel = `${prefix}.reportsLabel`;

export const ENGLISH = {
    [allAlertsLabel]: 'All Alerts',
    [alertConfigLabel]: 'Alert Config',
    [alertActionsLabel]: 'Alert Actions',
    [allEventsLabel]: 'All Events',
    [configAuditTrailLabel]: 'Config Audit Trail',
    [notificationsLabel]: 'Notifications',
    [snmpTrapLabel]: 'SNMP Trap',
    [trafficCaptureLabel]: 'Traffic Capture',
    [reportsLabel]: 'Reports',
};
